import { render, staticRenderFns } from "./estimates.vue?vue&type=template&id=3158c091"
import script from "./estimates.vue?vue&type=script&lang=js"
export * from "./estimates.vue?vue&type=script&lang=js"
import style0 from "./estimates.vue?vue&type=style&index=0&id=3158c091&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports